import { queryOptions } from '@tanstack/react-query';

import { apiClient } from '@/resources/upgrade/jsonapi-client';
import { ISession } from '@/resources/upgrade/Session';
import { enrichThinProfile } from '@/resources/upgrade/ThinProfile';
import { enrichUser } from '@/resources/upgrade/User';

export function sessionQueryOptions() {
  return queryOptions({
    queryKey: ['sessions', 'me'],
    queryFn: async () => {
      // Single resource endpoint - kitsu hoists data directly
      const data = await apiClient.get<ISession>('sessions/me', {
        include: 'user,main_profile',
      });

      data.user = data.user ? enrichUser(data.user) : null;
      data.main_profile = data.main_profile ? enrichThinProfile(data.main_profile) : null;

      return data as ISession;
    },
    staleTime: 1000 * 60 * 5,
    retry: (failureCount, error) => {
      // Don't retry on 401 unauthorized
      if ((error as any)?.response?.status === 401) {
        return false;
      }
      return failureCount < 3;
    },
  });
}
